module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCreative.3884682.webp";